import React, { PropsWithChildren } from 'react';

const hasUserInteractedContext = React.createContext({
  hasUserInteracted: false,
  setHasUserInteracted: (value: boolean) => {},
});

const WithHasUserInteracted = ({
  children,
  hasInteracted = false,
}: PropsWithChildren<{
  hasInteracted?: boolean;
}>) => {
  const [hasUserInteractedWithChildren, setHasUserInteractedWithChildren] =
    React.useState(hasInteracted);

  React.useEffect(() => {
    setHasUserInteractedWithChildren(hasInteracted);
  }, [hasInteracted]);

  return (
    <hasUserInteractedContext.Provider
      value={{
        hasUserInteracted: hasUserInteractedWithChildren,
        setHasUserInteracted: setHasUserInteractedWithChildren,
      }}
    >
      {children}
    </hasUserInteractedContext.Provider>
  );
};

export const useHasUserInteracted = () => {
  const context = React.useContext(hasUserInteractedContext);

  if (context === undefined) {
    throw new Error(
      'useHasUserInteracted must be used within a WithHasUserInteracted component'
    );
  }
  return context;
};

export default WithHasUserInteracted;
